/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddRoleDto
 */
export interface AddRoleDto {
    /**
     * 
     * @type {string}
     * @memberof AddRoleDto
     */
    roleName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddRoleDto
     */
    applicationUserId: string;
    /**
     * 
     * @type {string}
     * @memberof AddRoleDto
     */
    organizationId?: string | null;
}

/**
 * Check if a given object implements the AddRoleDto interface.
 */
export function instanceOfAddRoleDto(value: object): value is AddRoleDto {
    if (!('roleName' in value) || value['roleName'] === undefined) return false;
    if (!('applicationUserId' in value) || value['applicationUserId'] === undefined) return false;
    return true;
}

export function AddRoleDtoFromJSON(json: any): AddRoleDto {
    return AddRoleDtoFromJSONTyped(json, false);
}

export function AddRoleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddRoleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'roleName': json['roleName'],
        'applicationUserId': json['applicationUserId'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
    };
}

export function AddRoleDtoToJSON(json: any): AddRoleDto {
    return AddRoleDtoToJSONTyped(json, false);
}

export function AddRoleDtoToJSONTyped(value?: AddRoleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleName': value['roleName'],
        'applicationUserId': value['applicationUserId'],
        'organizationId': value['organizationId'],
    };
}

